// extracted by mini-css-extract-plugin
module.exports = {"container":"StatisticsResultsHeader_container__1bX5m"};